(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

var contact = document.getElementsByClassName("js-contact-wrap")[0];
var contact_close = document.getElementsByClassName("js-contact__close")[0];
var contact_overlay = document.getElementsByClassName("js-contact__overlay")[0];
var contact_calls = document.getElementsByClassName("js-contact");

function toggleScroll() {
    if (document.getElementsByClassName("header__nav")[0].classList.contains("mobile")) {} else {
        document.getElementsByTagName('body')[0].classList.toggle("noscroll");
    }
}

for (var i = 0; i < contact_calls.length; i++) {
    contact_calls[i].onclick = function () {
        event.preventDefault();
        contact.classList.toggle("contact-show");
        toggleScroll();
    };
}

function clearResponseWpcf7() {
    contact.classList.toggle("contact-show");
    var response = document.getElementsByClassName('wpcf7-response-output');
    if (response.length) {
        response[0].classList.add('wpcf7-display-none');
        response[0].classList.remove('wpcf7-validation-errors');
        response[0].style.display = 'none';
    }
    var not_valid = document.getElementsByClassName('wpcf7-not-valid-tip');
    if (not_valid.length) {
        for (var i = not_valid.length; i > 0; i--) {
            not_valid[i - 1].remove();
        }
    }
    document.getElementById("js-reset").click();
}

contact_close.onclick = function (event) {
    event.preventDefault();
    clearResponseWpcf7();
    toggleScroll();
};
contact_overlay.onclick = function () {
    clearResponseWpcf7();
    toggleScroll();
};

/**
 * Add validation rules
 */
document.addEventListener('wpcf7invalid', function () {

    jQuery('.wpcf7-form-control.wpcf7-not-valid').on('input', function () {
        jQuery(this.nextSibling).remove();
        if (jQuery('.wpcf7-not-valid-tip').length === 0) {
            var response = document.getElementsByClassName('wpcf7-response-output');
            if (response.length) {
                response[0].classList.add('wpcf7-display-none');
                response[0].classList.remove('wpcf7-validation-errors');
                response[0].style.display = 'none';
            }
        }
    });
});

},{}],2:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', function () {
    var iosBg = document.getElementsByClassName('youtube-bg__overlay');
    if (iosBg.length > 0) {
        if (/iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
            iosBg[0].classList.add('ios_bg');
        }
    }
});

},{}],3:[function(require,module,exports){
'use strict';

(function () {
    var _overlay = document.querySelector('.header__nav');
    var _clientY = null;
    _overlay.addEventListener('touchstart', function (event) {
        if (event.targetTouches.length === 1) {
            _clientY = event.targetTouches[0].clientY;
        }
    }, false);
    _overlay.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length === 1) {
            disableRubberBand(event);
        }
    }, false);
    function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;
        if (_overlay.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }
        if (isOverlayTotallyScrolled() && clientY < 0) {
            event.preventDefault();
        }
    }
    function isOverlayTotallyScrolled() {
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
})();

(function () {
    var _overlay = document.querySelector('.js-contact__modal');
    var _clientY = null;
    _overlay.addEventListener('touchstart', function (event) {
        if (event.targetTouches.length === 1) {
            _clientY = event.targetTouches[0].clientY;
        }
    }, false);
    _overlay.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length === 1) {
            disableRubberBand(event);
        }
    }, false);
    function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;
        if (_overlay.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }
        if (isOverlayTotallyScrolled() && clientY < 0) {
            event.preventDefault();
        }
    }
    function isOverlayTotallyScrolled() {
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
})();

},{}],4:[function(require,module,exports){
"use strict";

var mobileMenu = document.getElementsByClassName("header__nav")[0];
var mobileMenu_call = document.getElementsByClassName("header__burger")[0];
var overlay = document.getElementsByClassName("overlay")[0];

mobileMenu_call.onclick = function () {
    mobileMenu.classList.toggle("mobile");
    this.classList.toggle("close-burger");
    document.getElementsByTagName('body')[0].classList.toggle("noscroll");
};

},{}],5:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  $('body').on('click', '.show-detail, .close-detail', function () {
    $('.photogallery_detail').toggleClass('detail__show');
    $('.photogallery__wrap').toggleClass('fade_left');
    $('body').toggleClass('noscroll');
  });
  $('body').on('click', '.js-photogallery__close, .js-photogallery-open', function (e) {
    e.preventDefault();
    var photogallery = $(this).parents('.post').find('.photogallery');
    console.log('click');
    $('.header').toggleClass('fixed');
    photogallery.toggleClass('photogallery__show');
    if (photogallery.hasClass('photogallery__show')) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', 'auto');
    }
    if (!photogallery.hasClass('js-loaded')) {
      /* Photogallery AJAX post load */
      $.ajax({
        type: 'POST',
        data: {
          action: 'ajax_photography_loader',
          nonce_code: ajax_front.nonce,
          post_id: photogallery.data('id')
        },
        url: ajax_front.url,
        beforeSend: function beforeSend() {
          photogallery.addClass('js-loader').addClass('photogallery__show');
        },
        success: function success(data) {
          if (data) {
            photogallery.addClass('js-loaded').html(data).find('.fotorama').on('fotorama:ready fotorama:load', function (e, fotorama, extra) {
              photogallery.removeClass('js-loader');
            }).fotorama();
          }
        }
      });
      /* End Photogallery AJAX post load */
    }
  });
});

},{}],6:[function(require,module,exports){
"use strict";

$(document).ready(function () {
    function toggle_video_modal() {
        $('body').on("click", ".js-trigger-video-modal", function (e) {
            e.preventDefault();
            var id = $(this).attr('data-youtube-id');
            var autoplay = '?autoplay=1';
            var related_no = '&rel=0';
            var src = '//www.youtube.com/embed/' + id + autoplay + related_no;
            $("#youtube").attr('src', src);
            $("body").addClass("show-video-modal noscroll");
        });

        function close_video_modal() {
            event.preventDefault();
            $("body").removeClass("show-video-modal noscroll");
            $("#youtube").attr('src', '');
        }

        $('body').on('click', '.close-video-modal, .video-modal .overlay', function (e) {
            close_video_modal();
        });

        $('body').keyup(function (e) {
            if (e.keyCode == 27) {
                close_video_modal();
            }
        });
    }
    toggle_video_modal();
});

},{}],7:[function(require,module,exports){
'use strict';

require('./_mobileMenu.js');
require('./_contactModal.js');
require('./_youtubeModal.js');
require('./_photogallery.js');
require('./_iosBackground.js');
require('./_iosOffScroll.js');

},{"./_contactModal.js":1,"./_iosBackground.js":2,"./_iosOffScroll.js":3,"./_mobileMenu.js":4,"./_photogallery.js":5,"./_youtubeModal.js":6}]},{},[7]);
